/**
 * Get the API URL from environment variables
 * @returns {string} The API URL
 */
export const getApiUrl = () => {
    return process.env.REACT_APP_API_URL || 'http://localhost:7172';
};

/**
 * Get the current environment
 * @returns {string} 'development' or 'production'
 */
export const getEnvironment = () => {
    return process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development';
};

/**
 * Check if running in development environment
 * @returns {boolean}
 */
export const isDevelopmentEnvironment = () => {
    return getEnvironment() === 'development';
};

/**
 * Check if running in production environment
 * @returns {boolean}
 */
export const isProductionEnvironment = () => {
    return getEnvironment() === 'production';
};

/**
 * Legacy aliases for backward compatibility
 */
export const isTestEnvironment = isDevelopmentEnvironment;
export const isLiveEnvironment = isProductionEnvironment;

export default {
    getApiUrl,
    getEnvironment,
    isTestEnvironment,
    isLiveEnvironment
};
